export default __webpack_public_path__ + "9e85c262150260356ff29fad6c74b8a9.png";